import styled from 'styled-components';
import { Box } from 'rebass/styled-components';

export const ScrollBox = styled(Box)`
  overflow-y: scroll;
  overflow-x: ${({ overflowX }) => overflowX || 'hidden'};
  scrollbar-width: thin;
  scrollbar-color: #dee3ed transparent;
`;
